import { createContext, Dispatch, ReactNode, useEffect, useReducer } from "react"
import { getUserInSession } from "../endpoints"
import { UserActionInterface, UserInSessionInterface } from "../types"

export const UserContext = createContext<UserInSessionInterface>({
    user: { firstName: "guest", lastName: "guest", email: "email", userRole: "customer" },
    supervisor: null,
})
export const UserDispatchContext = createContext<Dispatch<UserActionInterface> | null>(null)

export function UserProvider({ children }: { children: ReactNode }) {
    const [user, dispatch] = useReducer(userReducer, {
        user: { firstName: "guest", lastName: "guest", email: "email", userRole: "customer" },
        supervisor: null,
    })
    useEffect(() => {
        ;(async () => {
            const result = await getUserInSession()
            // consolelog('result',result)
            if (result.code === 1000) {
                dispatch({ type: "LOGIN", payload: result.user })
            }
        })()
    }, [])

    return (
        <UserContext.Provider value={user}>
            <UserDispatchContext.Provider value={dispatch}>{children}</UserDispatchContext.Provider>
        </UserContext.Provider>
    )
}
function userReducer(user: UserInSessionInterface, action: UserActionInterface) {
    // console.log(action)

    switch (action.type) {
        case "LOGIN": {
            return action.payload
        }
        case "LOGOUT": {
            return { user: null, supervisor: null }
        }
        case "UPDATE_USER": {
            return action.payload
        }

        default: {
            throw Error("Unknown user action: " + action.type)
        }
    }
}
